module.exports = __webpack_public_path__ + "static/media/background-institucional.91e5dd46.png";